module.exports = __webpack_public_path__ + "static/media/age_rating_18.662c8e14.svg";